import React, { useState, useEffect } from "react";
import WikiRoutes from "./pages/WikiRoutes";
import Login from "./Login";
import axios from "./axiosConfig";
import { jwtDecode } from "jwt-decode"; // 

function isTokenExpired(token) {
  try {
    const decoded = jwtDecode(token);
    return decoded.exp * 1000 < Date.now(); // JWT uses seconds; JS uses ms
  } catch {
    return true; // Treat parsing errors as expired
  }
}

function App() {
  const [token, setToken] = useState(null);

  useEffect(() => {
    const savedToken = localStorage.getItem("jwt_token");
    if (savedToken && !isTokenExpired(savedToken)) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${savedToken}`;
      setToken(savedToken);
    } else {
      localStorage.removeItem("jwt_token");
      setToken(null);
    }
  }, []);

  if (!token) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50 p-4 dark:bg-slate-950">
        <Login
          onLogin={() => {
            const savedToken = localStorage.getItem("jwt_token");
            if (savedToken && !isTokenExpired(savedToken)) {
              axios.defaults.headers.common["Authorization"] = `Bearer ${savedToken}`;
              setToken(savedToken);
            }
          }}
        />
      </div>
    );
  }

  return <WikiRoutes />;
}

export default App;

